import PropTypes from "prop-types"
import React from "react"
import PaymentMethodDropdownOption from "src/main/Billing/PaymentMethodDropdownOption"

import Form from "src/components/Form"

const TYPE_BY_KIND = {
  card: "PaymentMethod::Card",
  us_bank_account: "PaymentMethod::BankAccount",
}

const SavedMethodSelect = ({ kind, paymentMethods, value, onChange, copy }) => {
  const savedOfKind = paymentMethods.filter(
    (paymentMethod) => paymentMethod.type === TYPE_BY_KIND[kind]
  )

  return (
    <Form.Select.Custom
      formLabel={copy.savedPaymentMethod}
      onChange={onChange}
      value={value}
    >
      <Form.Select.RichOption value="" hideCheck>
        {copy.savedPaymentMethodPlaceholder}
      </Form.Select.RichOption>
      {savedOfKind.map((paymentMethod) => (
        <Form.Select.RichOption
          key={paymentMethod.id}
          value={paymentMethod.stripePaymentMethodId}
          hideCheck
        >
          <PaymentMethodDropdownOption
            paymentMethod={paymentMethod}
            includeExpirationDates
          />
        </Form.Select.RichOption>
      ))}
      <Form.Select.RichOption value="add">
        {copy.addNewMethod}
      </Form.Select.RichOption>
    </Form.Select.Custom>
  )
}

SavedMethodSelect.propTypes = {
  kind: PropTypes.oneOf(["card", "us_bank_account"]).isRequired,
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      stripePaymentMethodId: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  copy: PropTypes.shape({
    addNewMethod: PropTypes.string,
    savedPaymentMethod: PropTypes.string,
    savedPaymentMethodPlaceholder: PropTypes.string,
  }).isRequired,
}

export default SavedMethodSelect
